// extracted by mini-css-extract-plugin
module.exports = {"icon":"DownArrowIcon_icon__1eLZu"};